import React, { lazy, Suspense } from 'react'
import HeaderSection from 'partials/header'
import RecommendSection from 'partials/recommend'

const MatchaSection = lazy(() => import('partials/matcha'))
const FindSection = lazy(() => import('partials/find'))
const CelebrateSection = lazy(() => import('partials/celebrate'))
const HomemadeSection = lazy(() => import('partials/homemade'))
const TasteSection = lazy(() => import('partials/taste'))

const LandingPage = () => {
  return (
    <div>
      <HeaderSection />
      <main>
        <RecommendSection />
        <Suspense fallback={<span>Loading...</span>}>
          <MatchaSection />
          <FindSection />
          <CelebrateSection />
          <HomemadeSection />
          <TasteSection className="mt-24" />
        </Suspense>
      </main>
    </div>
  )
}

export default LandingPage
